<script lang="ts">
  import { loadInternalLink } from '#app/lib/utils'
  import ImagesCollage from '#components/images_collage.svelte'
  import type { SerializedListing } from '#listings/lib/listings'
  import { getListingElementsImages } from '#listings/lib/listings'
  import { getSerializedUser } from '#users/users_data'

  const {
    listing,
  }: {
    listing: SerializedListing
  } = $props()

  let username = $state()
  const imagesLimit = 6

  async function getCreator () {
    ;({ username } = await getSerializedUser(listing.creator))
  }

  const waitingForUserdata = getCreator()
  const waitingForImages = $derived(getListingElementsImages(listing, imagesLimit))
</script>

<a
  href={`/lists/${listing._id}`}
  class="entity-listing-layout"
  onclick={loadInternalLink}
>
  <div class="listing-name-section">
    <div>{listing.name}</div>
    {#await waitingForUserdata then}
      <span class="username">{username}</span>
    {/await}
  </div>
  {#await waitingForImages then imagesUrls}
    <ImagesCollage
      {imagesUrls}
      limit={imagesLimit}
      imageSize={64}
    />
  {/await}
</a>

<style lang="scss">
  @import "general/scss/utils";
  .entity-listing-layout{
    @include display-flex(column, flex-start);
    padding: 0.5em;
    background-color: $light-grey;
    :global(.images-collage){
      block-size: 5em;
    }
    &:not(:last-child){
      margin-block-end: 1em;
    }
    &:hover, &:focus{
      background-color: darken(white, 1%);
    }
  }
  .listing-name-section{
    width: 100%;
    @include display-flex(row, center, space-between);
    padding: 0.5em;
  }
  .username{
    align-self: end;
  }
</style>
